import { useQuery } from "@tanstack/react-query";
import { getScanReport, getScans } from "../../api";

export const useGetScans = (page, status, schedule) => {
  const query = useQuery({
    queryKey: ["scans", page, status, schedule],
    queryFn: () => getScans({page, status, schedule}),
  });
  return {
    isLoading: query.isPending,
    isSuccess: query.isSuccess,
    isError: query.isError,
    data: query.data,
    refetch: query.refetch,
  };
};

export const useGetScanReport = (id) => {
  const query = useQuery({
    queryKey: ["scan-report", id],
    queryFn: () => getScanReport(id),
  });
  return {
    isLoading: query.isPending,
    isSuccess: query.isSuccess,
    isError: query.isError,
    data: query.data,
    refetch: query.refetch,
  };
};
